module.exports = __webpack_public_path__ + "static/media/compu.4adec2fc.png";